import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';
import { YodaBorderRadius, YodaColors, YodaFontSize, YodaJustifyContent, YodaSpacing } from 'yoda-ui/yodaTheme';

export const contentSwitcherWrapper: SxProps<Theme> = {
  backgroundColor: YodaColors.white,
  padding: '24px',
  borderRadius: YodaBorderRadius.medium,
};

export const buttonSwitcherWrapper: SxProps<Theme> = {
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: YodaJustifyContent.spaceBetween,
  marginBottom: YodaSpacing.small,
  height: '60px',
};

export const contentSwitcherTitle: SxProps<Theme> = {
  flex: '50%',
  textAlign: 'left',
  fontSize: YodaFontSize.xLarge,
  fontWeight: 700,
};
